import { CartProductModifierDto } from '../dto/cartProductModifier.dto';

export interface CartProductModifierGroupDto {
  modifierGroup: string;
  minRequired?: number;
  maxAllowed?: number;
  modifiers: CartProductModifierDto[];
  cartProductId?: number;
  id?: number;
}
